export default __webpack_public_path__ + "static/IMG_1257_opti-2f18f8098748e4939efadf810ef34b4f.jpg";